import { createApp } from "vue"
import SearchableDropdown from "../components/SearchableDropdown.vue"

const mountedApps = new WeakMap()
const searchableDropdownQuery = "[data-vue-searchable-dropdown]"

function mountVueApp(element, props) {
  if (mountedApps.has(element)) return

  const app = createApp(SearchableDropdown, props)
  app.mount(element)
  mountedApps.set(element, app)
}

function mountSearchableDropdowns() {
  document.querySelectorAll(searchableDropdownQuery).forEach((element) => {
    mountVueApp(element, {
      options: JSON.parse(element.dataset.optionsValue || "[]"),
      initialSelectedValue: element.dataset.selectedValue || null,
      inputName: element.dataset.inputName,
      searchInputId: element.dataset.searchInputId,
      clearText: element.dataset.clearText,
      noResultsText: element.dataset.noResultsText,
      searchLabel: element.dataset.searchLabel,
      searchPlaceholder: element.dataset.searchPlaceholder,
      resetEventTarget: element
    })
  })
}

function unmountSearchableDropdowns() {
  document.querySelectorAll(searchableDropdownQuery).forEach((element) => {
    unmountVueApp(element)
  })
}

function unmountSearchableDropdownsInside(container) {
  if (container.matches(searchableDropdownQuery)) {
    unmountVueApp(container)
  }

  container.querySelectorAll(searchableDropdownQuery).forEach((element) => {
    unmountVueApp(element)
  })
}

function unmountVueApp(element) {
  const app = mountedApps.get(element)
  if (!app) return

  app.unmount()
  mountedApps.delete(element)
}

document.addEventListener("turbo:load", mountSearchableDropdowns)
document.addEventListener("turbo:before-cache", unmountSearchableDropdowns)
document.addEventListener("turbo:frame-load", mountSearchableDropdowns)
document.addEventListener("turbo:before-stream-render", (event) => {
  const targetId = event.target.getAttribute("target")
  const target = targetId ? document.getElementById(targetId) : null
  if (target) unmountSearchableDropdownsInside(target)

  const render = event.detail.render
  event.detail.render = (streamElement) => {
    render(streamElement)
    mountSearchableDropdowns()
  }
})
mountSearchableDropdowns()
